import { get } from "../utils";
import Client from "src/types/models/Client";

export async function getClient(): Promise<Client> {
  return (await get({ path: "outdefine_hire/client" })).body?.client as Client;
}
